import { render, staticRenderFns } from "./KanbanBoard.vue?vue&type=template&id=a30ba858&scoped=true&"
import script from "./KanbanBoard.vue?vue&type=script&lang=js&"
export * from "./KanbanBoard.vue?vue&type=script&lang=js&"
import style0 from "./KanbanBoard.vue?vue&type=style&index=0&id=a30ba858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30ba858",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {KanbanCard: require('/workspace/components/KanbanBoard/KanbanCard.vue').default})
